export default __webpack_public_path__ + "static/assets/med_x_ampoule_1.264ff1cd.png";